import { Fragment, memo, ReactElement } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import FormFilter from './form';

interface FilterActProps {
  open?: boolean;
  setOpen: (value: boolean) => void;
}

const FilterActComponent = ({ open, setOpen }: FilterActProps): ReactElement => {
  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="filter-act-content"
          id="panel-filter-act-header"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        >
          <Typography>Filtri di ricerca</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormFilter />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

FilterActComponent.displayName = 'Practice Research - Filter Practice component';

const FilterAct = memo(FilterActComponent);

export default FilterAct;
